import { Dialog, DialogContent, DialogTitle, IconButton, styled } from '@mui/material';
import { ReactElement, useState } from 'react';
import DeleteButton from './DeleteButton';
import CloseConfirmDialog from '../CloseConfirmDialog';

const StyledWidgetIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderRadius: '3px',
  padding: '2px',
  '&:hover': {
    color: theme.palette.text.secondary,
    backgroundColor: `${theme.palette.action.hover} !important`,
  },
  '&:focus-visible': {
    backgroundColor: theme.palette.action.hover,
  },
}));

interface SettingsMenuProps {
  id: string;
  widgetId: string;
  children?: ReactElement;
  onWidgetClose?: () => void;
  isHideDeleteButton?: boolean;
  isCloseConfirmDialog: boolean;
  setIsCloseConfirmDialog: (isCloseConfirmDialog: boolean) => void;
}

export const SettingsMenu = ({
  id,
  widgetId,
  children,
  onWidgetClose,
  isHideDeleteButton,
  isCloseConfirmDialog,
  setIsCloseConfirmDialog,
}: SettingsMenuProps) => {
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false);

  const onOpenSettings = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsSettingsDialogOpen(true);
  };

  const onCloseSettings = () => setIsSettingsDialogOpen(false);

  return (
    <>
      {children && (
        <StyledWidgetIcon id={id} onClick={onOpenSettings} sx={{ fontSize: '18px' }}>
          <i className="ri-more-fill" aria-hidden="true" />
        </StyledWidgetIcon>
      )}
      {!isHideDeleteButton && <DeleteButton id={widgetId} variant="link" onWidgetClose={() => setIsCloseConfirmDialog(true)} />}
      <Dialog
        id={`${id}-menu`}
        keepMounted
        open={isSettingsDialogOpen}
        onClose={onCloseSettings}
        fullWidth
        maxWidth="xl"
        sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ margin: 0, padding: '2px 2px 0 0 ', textAlign: 'right' }}>
          <IconButton onClick={onCloseSettings}>
            <span className="ri-close-line" aria-hidden="true" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 64px)' }}>{children}</DialogContent>
      </Dialog>
      <CloseConfirmDialog open={isCloseConfirmDialog} setOpen={setIsCloseConfirmDialog} onClose={onWidgetClose} id={widgetId} />
    </>
  );
};
